module.exports = "\n<h3 class=\"text-center\" ng-if=\"vm.show\">\n  {{ 'PLEASE_WAIT' | translate }}\n</h3>\n";